/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/queries/quizMeQueries.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */

import { isAcceptanceTest } from 'hub-http/helpers/env';
import { useEffect, useState } from 'react';
import { NetworkStatus } from '@apollo/client';
import I18n from 'I18n';
import { useAsyncBulkGenerateQuizMeMutation, useAsyncBulkGetQuizMeLazyQuery } from '../../../../__generated__/chirp/com/hubspot/academy/gen/ai/skills/rpc/QuizMeRpc.hooks';
import { checkQuizMePollingStatus, collectTaskIdsFromState, selectPollTaskByTaskId, useQuizMeSession } from '../utils/quizMeUtils.migrated';
import { handleApolloErrors } from '../../../utils/errorUtils.legacy';
/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/queries/quizMeQueries.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const useGenerateQuizMeTrackIds = options => {
  const [asyncGenerateQuizMe, {
    loading: generateQuizTrackIdsLoading,
    error: generateQuizTrackIdsError,
    data: generateQuizTrackIds
  }] = useAsyncBulkGenerateQuizMeMutation(Object.assign({
    onError: err => handleApolloErrors({
      error: err,
      loggingTitle: 'learningCenter.interactiveEducation.errors.asyncQuizGenerationError'
    })
  }, options));
  return {
    asyncGenerateQuizMe,
    generateQuizTrackIdsLoading,
    generateQuizTrackIdsError,
    generateQuizTrackIds
  };
};
/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/queries/quizMeQueries.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const useAsyncGetLazyPollingQuizMe = ({
  options,
  contentIds,
  contentType
}) => {
  const [pollCount, setPollCount] = useState(0);
  const [quizMeLoading, setQuizMeLoading] = useState(false);
  const [quizMeError, setQuizMeError] = useState();
  const {
    setQuizMeStatus,
    getQuizState
  } = useQuizMeSession();
  const [getQuizMeLazy, {
    data,
    loading: queryLoading,
    error,
    stopPolling,
    networkStatus
  }] = useAsyncBulkGetQuizMeLazyQuery(Object.assign({
    notifyOnNetworkStatusChange: true,
    pollInterval: 3000,
    onError: err => {
      if (pollCount < 2) {
        setQuizMeError(err);
        handleApolloErrors({
          error: err,
          loggingTitle: 'learningCenter.interactiveEducation.errors.asyncQuizMeGetQuizError'
        });
      }
    },
    skip: isAcceptanceTest()
  }, options));
  const isPolling = networkStatus === NetworkStatus.poll || queryLoading;
  const {
    quizReady,
    retryGeneration
  } = checkQuizMePollingStatus(data, !!error);
  useEffect(() => {
    if (!quizReady && isPolling) {
      setPollCount(prev => prev + 1);
      setQuizMeLoading(true);
    }
    const hasExceededPollLimit = pollCount > 20;
    const shouldStopPolling = hasExceededPollLimit || quizReady || retryGeneration;
    if (shouldStopPolling) {
      if (hasExceededPollLimit) {
        setQuizMeError({
          message: I18n.text('learningCenter.interactiveEducation.errors.asyncQuizMeGetQuizError'),
          name: 'QuizGenerationError'
        });
      } else {
        setQuizMeError(undefined);
      }
      stopPolling();
      setPollCount(0);
      setQuizMeLoading(false);
    }
    if (data) {
      contentIds.forEach(contentId => {
        const [representativeTaskId] = collectTaskIdsFromState(getQuizState(contentId, contentType));
        const task = selectPollTaskByTaskId(data.tasks, representativeTaskId);
        if (task) setQuizMeStatus({
          contentType,
          contentId,
          quizMeStatus: task.status
        });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stopPolling, data, error, isPolling]);
  return {
    getQuizMeLazy,
    queryLoading,
    quizMeLoading,
    quizMeError,
    data,
    retryGeneration
  };
};